import React from "react";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Testimoni1 from '../../Assets/testimoni1.jpg'

export function Testimoni () {
    return (
        <Container fluid='xl' style={{minHeight : '50vh'}}>
        <h4 className="my-3 text-white text-center">Testimoni</h4>
        <div className="d-flex flex-wrap justify-content-around">
            <Card style={{ width: '18rem' }} className='m-2'><Card.Img variant="top" src={Testimoni1} /></Card>
        </div>
    </Container>
    )
}